//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Facet.js";
import "../no/Builder.js";
import "../no/SelectDisplayableObjectList.js";
import "../Facet/Facet.SelectFacetedBodyList.js";
import "../no/SectionList.js";
import "../GeometricUtilities/GeometricUtilities.BoundaryDefinitionBuilderList.js";
import "../no/SelectPointList.js";
import "../no/ugmath.js";
import "../no/FacetCollector.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[0,"AlongDirection",1,0],[0,"AutomaticFillType",1,0],[1,"Bodies",0,"SelectDisplayableObjectList",0],[0,"BoundaryFacetTreatmentType",1,0],[0,"CanDivide",1,0],[1,"FacetBodies",0,"Facet.SelectFacetedBodyList",1],[0,"FacetCollector",1,"FacetCollector",0],[0,"IsEditCopy",1,0],[0,"IsSnipNearFacets",1,0],[0,"Plane",1,"Plane",0],[1,"ProfileList",0,"SectionList",0],[0,"ProjectBothSides",1,0],[0,"ProjectionVector",1,"Direction",0],[1,"RegionList",0,"GeometricUtilities.BoundaryDefinitionBuilderList",0],[1,"RegionPoint",0,"SelectPointList",0],[0,"RegionsOption",1,0],[0,"Type",1,0],[0,"ViewDirection",1,0]],[[[],"SwitchRegion",{},0,0]],[]];
SPLM.Facet.SnipFacetBodyBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Facet.SnipFacetBodyBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Facet.SnipFacetBodyBuilder.Types = Object.freeze({
    "SnipByBoundary" : "SnipByBoundary", "SnipByRegion" : "SnipByRegion", "SnipWithCurves" : "SnipWithCurves", "SnipAtPlane" : "SnipAtPlane"});

SPLM.Facet.SnipFacetBodyBuilder.DirectionType = Object.freeze({
    "ViewDirection" : "ViewDirection", "FacetNormal" : "FacetNormal", "AlongVector" : "AlongVector"});

SPLM.Facet.SnipFacetBodyBuilder.BoundaryFacetTreatmentMethod = Object.freeze({
    "SnipFacets" : "SnipFacets", "RemoveFacets" : "RemoveFacets"});

SPLM.Facet.SnipFacetBodyBuilder.RegionsOptionType = Object.freeze({
    "RemoveSelected" : "RemoveSelected", "KeepSelected" : "KeepSelected", "Divide" : "Divide"});

SPLM.Facet.SnipFacetBodyBuilder.AutomaticFillTypes = Object.freeze({
    "None" : "None", "Linear" : "Linear", "Refined" : "Refined", "TangentBased" : "TangentBased", "CurvatureBased" : "CurvatureBased"});

export default SPLM;